import { useQuery } from "@apollo/client";

import { useShouldShowSubscriptionOverhaul } from "MVVM/Hooks/useSubscriptionOverhaul";
import { useUser } from "MVVM/Hooks/useUser";
import { CLIP_STORAGE_STATUS } from "MVVM/GraphQL/savedClipStatus";

export const useUnsavedDraftCount = (): number | null => {
  const showSubscriptionOverhaul = useShouldShowSubscriptionOverhaul();
  const { allstarUser } = useUser();

  const loggedIn = allstarUser?.loggedIn;

  const { data: storageData } = useQuery(CLIP_STORAGE_STATUS, {
    skip: !loggedIn || !showSubscriptionOverhaul,
    fetchPolicy: "cache-first",
  });

  const storageStatus = storageData?.me?.clipStorageStatus;

  if (!showSubscriptionOverhaul || !storageStatus) {
    return null;
  }

  const unsavedCount = storageStatus.unsavedCount ?? 0;

  return unsavedCount > 0 ? unsavedCount : null;
};
